import React from 'react';
import { BeltBadge } from '../ui/BeltBadge';

interface BeltDisplayProps {
    rank?: string;
    stripes?: number;
    size?: 'sm' | 'md' | 'lg';
    showStripes?: boolean;
}

// Deprecated compat layer - prefers passing 'rank' directly.
// If rank is missing, it should just render nothing or fallback (previous logic fetched profile).
// However, most call sites pass rank. If not, we should probably fetch it, but let's stick to simple replacement for now
// and fix call sites if they rely on internal fetching.
// Based on grep, TopBar and Dropdown use internal fetching.
// We need to support that or refactor them.
// Let's refactor them to fetch data themselves or use a context, but to stay safe, let's restore the fetching logic WRAPPED around BeltBadge.

import { useStudentProfile } from '@/hooks/useStudentProfile';
import { useAuth } from '@/features/auth/AuthProvider';
import { useActiveChild } from '@/contexts/ActiveChildContext';

export const BeltDisplay: React.FC<BeltDisplayProps> = ({ rank, stripes, size = 'md', showStripes = true }) => {
    const { currentUser } = useAuth();
    const { activeChildId } = useActiveChild();

    // If rank is provided, use it. Otherwise, fetch logic:
    // If activeChildId is present, fetch THEIR profile.
    // If not, fetch currentUser's profile.
    const shouldFetch = !rank;
    const targetId = activeChildId || currentUser?.uid;

    const { profile, loading } = useStudentProfile(shouldFetch ? targetId : undefined);

    const displayRank = rank || profile?.belt;
    const displayStripes = stripes !== undefined ? stripes : (profile?.stripes || 0);

    if ((shouldFetch && loading) || !displayRank) return null;

    return <BeltBadge rank={displayRank} stripes={displayStripes} size={size} showStripes={showStripes} />;
};
